import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import If from 'src/components/Shared/If/If';
import Phone from 'src/components/Shared/Phone/Phone';
import config from 'src/config/config';
import { setProgress as actionSetProgress } from 'src/redux/modules/progress';
import {
  APP_TOLL_FREE_NUMBER,
  COLLEGE_FUND_NOTE_CANNOT_LINK_BANK_FORM_URL,
  COLLEGE_FUND_NOTE_PHONE_NUMBERS,
  FundNoteAutoBuy,
  FundNoteBuy,
  TOLL_FREE_NUMBER,
} from 'src/settings/settings';
import { scrollElementIntoFullView } from 'src/utils/dom-utils';
import { isProductType529 } from 'src/utils/funds/funds-utility';
import { appendBasePath } from '../../../../utils/nav.utils';
import AddressUndeliverableFundNoteTip from './AddressUndeliverableFundNoteTip';
import ESAPlanFundNoteTip from './ESAPlanFundNoteTip';
import FundNote from './FundNote';
import './FundNote.module.scss';
import RestrictedCountryFundNoteTip from './RestrictedCountryFundNoteTip';
import SignatureRequiredFundNoteTip from './SignatureRequiredFundNoteTip';

const RecurringBuyFundNotes = ({ fund, setProgress }) => {
  const autoBuyLabel =
    fund.agreementType === 'COLLEGE_SAVINGS'
      ? 'Automatic Monthly Contribution'
      : 'Automatic Buy';

  const autoBuyFundLabel =
    fund.agreementType === 'COLLEGE_SAVINGS' ? 'portfolio' : 'fund';
  const updateLinkAMC = `${config.url}/usis/transactions/automatic`;
  return (
    <Fragment>
      <If test={fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_GATE_ACTIVE]}>
        <FundNote
          labelSubText={
            <div
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
              className="exclude"
            />
          }
          labelText="Redemption Block"
          showToolTip={false}
        />
      </If>
      <If test={fund.notes[FundNoteBuy.PENDING_STATUS]}>
        <FundNote labelText="Pending Bank Association" showToolTip={false} />
      </If>
      <If test={fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_GATE_REMOVED]}>
        <FundNote
          labelSubText={
            <div
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
              className="exclude"
            />
          }
          labelText="Redemption Block Removed"
          showToolTip={false}
        />
      </If>
      <If test={fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_FEE_ACTIVE]}>
        <FundNote
          labelSubText={
            <div
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
              className="exclude"
            />
          }
          labelText="Liquidity Fee"
          showToolTip={false}
        />
      </If>
      <If test={fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_FEE_REMOVED]}>
        <FundNote
          labelSubText={
            <div
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
              className="exclude"
            />
          }
          labelText="Liquidity Fee Removed"
          showToolTip={false}
        />
      </If>
      <If test={fund.notes[FundNoteBuy.IRA_DECEASED]}>
        <FundNote
          labelSubText=""
          labelText="Change of Ownership Needed"
          tipHeader="Change of Ownership Needed"
          tipMessage={
            <div className="exclude">
              Change of Ownership Needed: Please{' '}
              <a
                className="exclude"
                href={`${config.url}/personal-investing/help/contact/index.html`}
                rel="noopener noreferrer"
                target="_blank"
              >
                contact us
              </a>{' '}
              to discuss options available with this account.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteBuy.INHERITED_FUND]}>
        <FundNote
          labelSubText=""
          labelText="Inherited IRA"
          tipHeader="Inherited IRA"
          tipMessage="You cannot purchase additional shares of an Inherited IRA."
        />
      </If>
      <If test={fund.notes[FundNoteBuy.CLOSED_NEW]}>
        <FundNote
          labelText="Closed to New Investors"
          tipHeader="Closed to New Investors"
          tipMessage="All shares previously redeemed, client cannot buy back into fund."
        />
      </If>
      <If test={fund.notes[FundNoteBuy.COUNTRY_RESTRICTED]}>
        <FundNote
          labelSubText="Requires Permanent US Address"
          labelText="Restricted"
          tipHeader="Restricted Country"
          tipMessage={<RestrictedCountryFundNoteTip fund={fund} />}
        />
      </If>
      <If test={fund.notes[FundNoteBuy.ESA_PLAN]}>
        <FundNote
          labelSubText=""
          labelText="ESA Plan"
          tipHeader="ESA Plan"
          tipMessage={<ESAPlanFundNoteTip />}
        />
      </If>
      <If test={fund.notes[FundNoteBuy.STOP_PURCHASE]}>
        <FundNote
          labelSubText=""
          labelText="Stop Purchase Applied"
          tipHeader="Stop Purchase"
          tipMessage={
            isProductType529(fund.productType) ? (
              <div className="exclude">
                This portfolio or account is unavailable for purchase.Please
                contact us at{' '}
                <Phone
                  phoneNumber={
                    COLLEGE_FUND_NOTE_PHONE_NUMBERS[fund.productType]
                  }
                />
              </div>
            ) : (
              <div className="exclude">
                T. Rowe Price has blocked purchases on this fund or account.{' '}
                <a
                  className="exclude"
                  href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                  rel="noreferrer"
                  target="_blank"
                >
                  Contact us
                </a>{' '}
                for more information.
              </div>
            )
          }
        />
      </If>
      <If
        test={
          fund.notes[FundNoteAutoBuy.STOP_PURCHASE] &&
          fund.productType === 'ManagedAccount'
        }
      >
        <FundNote
          labelSubText=""
          labelText="Stop Purchase Applied"
          tipHeader="Stop Purchase"
          tipMessage={
            <div className="exclude">
              T. Rowe Price has blocked purchases on this fund or account.{' '}
              <a
                className="exclude"
                href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                rel="noreferrer"
                target="_blank"
              >
                Contact us
              </a>{' '}
              for more information.
            </div>
          }
        />
      </If>
      <If
        test={
          fund.notes[FundNoteBuy.CANNOT_LINK_BANK] &&
          fund.productType === 'ManagedAccount'
        }
      >
        <FundNote
          labelSubText="Signature Required"
          labelText="Cannot Link Bank"
          tipHeader="Cannot Link Bank"
          tipMessage={
            <div className="exclude">
              Your account has a feature on it that restricts purchases. Call{' '}
              <Phone phoneNumber={APP_TOLL_FREE_NUMBER} /> to discuss options.
            </div>
          }
        />
      </If>
      <If
        test={
          fund.notes[FundNoteBuy.CANNOT_LINK_BANK] &&
          fund.productType !== 'ManagedAccount'
        }
      >
        <FundNote
          labelSubText="Signature Required"
          labelText="Cannot Link Bank"
          tipHeader="Cannot Link Bank"
          tipMessage={
            isProductType529(fund.productType) ? (
              <SignatureRequiredFundNoteTip
                college={true}
                formUrl={
                  COLLEGE_FUND_NOTE_CANNOT_LINK_BANK_FORM_URL[fund.productType]
                }
              />
            ) : (
              <SignatureRequiredFundNoteTip />
            )
          }
        />
      </If>
      <If
        test={
          fund.notes[FundNoteAutoBuy.PENDING] &&
          fund.productType === 'ManagedAccount'
        }
      >
        <FundNote
          labelSubText=""
          labelText="Transaction Pending"
          tipHeader="Transaction Pending"
          tipMessage="Account is part of a pending transaction."
        />
      </If>
      <If
        test={
          fund.notes[FundNoteAutoBuy.RETURN_E_MAIL_VERIFY_ADDRESS] &&
          fund.productType === 'ManagedAccount'
        }
      >
        <FundNote
          labelSubText=""
          labelText="Return Email"
          tipHeader="Return Email"
          tipMessage="We were unable to previously deliver a message to you electronically. Please verify or update your email address today."
        />
      </If>
      <If test={fund.notes[FundNoteBuy.ADDRESS_UNDELIVERABLE]}>
        <FundNote
          labelSubText=""
          labelText="Address Undeliverable"
          tipHeader="Address Undeliverable"
          tipMessage={
            <AddressUndeliverableFundNoteTip
              phoneNumber={
                isProductType529(fund.productType)
                  ? COLLEGE_FUND_NOTE_PHONE_NUMBERS[fund.productType]
                  : undefined
              }
            />
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoBuy.BANK_NOT_LINKED]}>
        <FundNote
          labelSubText=""
          labelText="Bank Not Linked"
          tipHeader="Bank Not Linked"
          tipMessage={
            <div className="exclude bankNotLinked">
              This {autoBuyFundLabel} is not connected to a bank on file. To
              continue,{' '}
              <a
                className="exclude college-branded-link"
                href={`${config.url}/usis/my-accounts/profile/linked-bank-accounts`}
              >
                link this bank
              </a>{' '}
              or{' '}
              <a
                className="exclude text-nowrap college-branded-link"
                onClick={() => {
                  setProgress(1);
                  scrollElementIntoFullView('funding-target-step');
                }}
              >
                choose a different bank.
              </a>
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteBuy.CANNOT_REOPEN_SUMMIT]}>
        <FundNote
          labelSubText=""
          labelText="Cannot Reopen"
          tipHeader="Cannot Reopen Fund"
          tipMessage={`Clients are not able to reopen ${fund?.name} by making contributions due to maximum IRA contribution limits.`}
        />
      </If>
      <If test={fund.notes[FundNoteBuy.CANNOT_REOPEN_ICLASS]}>
        <FundNote
          labelSubText=""
          labelText="Unable to Reopen Online"
          tipHeader="Unable to Reopen Online"
          tipMessage={
            <div className="exclude">
              Minimum required purchase is above online maximum. Call{' '}
              <Phone phoneNumber="(877) 218-5162" /> to reopen.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteBuy.ONLINE_PURCHASE_RESTRICTED]}>
        <FundNote
          labelSubText=""
          labelText="Unavailable for Purchase Online"
          tipHeader="Unavailable for Purchase Online"
          tipMessage={
            isProductType529(fund.productType) ? (
              <div className="exclude">
                Online/phone purchase disabled. Call{' '}
                <Phone
                  phoneNumber={
                    COLLEGE_FUND_NOTE_PHONE_NUMBERS[fund.productType]
                  }
                />{' '}
                to enable purchasing.
              </div>
            ) : (
              <div className="exclude">
                Online/phone purchase disabled. Call{' '}
                <Phone phoneNumber={TOLL_FREE_NUMBER} /> to enable purchasing.
              </div>
            )
          }
        />
      </If>

      <If test={fund.notes[FundNoteAutoBuy.CLOSED_FUND]}>
        <FundNote
          labelSubText=""
          labelText="Closed Fund Account"
          tipHeader="Closed Fund Account"
          tipMessage={
            <div className="exclude">
              All shares have been redeemed or exchanged in a previous
              transaction. Fund account must be re-opened with new account
              minimums before an Automatic Buy can be established. Fund can be
              re-opened by making a one-time{' '}
              <a
                className="exclude college-branded-link"
                href={`${appendBasePath('/buy')}`}
              >
                Mutual Fund Buy
              </a>
              .
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoBuy.IRA_AUTOMAX]}>
        <FundNote
          labelSubText=""
          labelText="IRA Automax"
          tipHeader="IRA Automax"
          tipMessage={
            <div className="exclude">
              An IRA Automax exists on this fund. To make changes,{' '}
              <a className="exclude college-branded-link" href={updateLinkAMC}>
                edit or delete
              </a>{' '}
              your existing plan.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoBuy.AUTO_BUY]}>
        <FundNote
          labelSubText=""
          labelText={autoBuyLabel}
          tipHeader={autoBuyLabel}
          tipMessage={
            <div className="exclude">
              An {autoBuyLabel} already exists on this {autoBuyFundLabel}. To
              make changes, please{' '}
              <a className="exclude college-branded-link" href={updateLinkAMC}>
                edit or delete
              </a>{' '}
              your existing plan.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoBuy.AUTO_SELL]}>
        <FundNote
          labelSubText=""
          labelText="Automatic Sell"
          tipHeader="Automatic Sell"
          tipMessage={
            <div className="exclude">
              An Automatic Sell exists on this fund. To make changes,{' '}
              <a className="exclude college-branded-link" href={updateLinkAMC}>
                edit or delete
              </a>{' '}
              your existing plan.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoBuy.AUTO_EXCHANGE]}>
        <FundNote
          labelSubText=""
          labelText="Automatic Exchange"
          tipHeader="Automatic Exchange"
          tipMessage={
            <div className="exclude">
              An Automatic Exchange exists on this fund. To make changes,{' '}
              <a className="exclude college-branded-link" href={updateLinkAMC}>
                edit or delete
              </a>{' '}
              your existing plan.
            </div>
          }
        />
      </If>
    </Fragment>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setProgress: actionSetProgress,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecurringBuyFundNotes);
